<template>
    <div>
        <div v-if="successMessage" class="alert alert-success" style="color: rgb(5, 20, 48)">
            {{ successMessage }}
        </div>
        <b-card>
            <b-row>
                <div class="col-12 mt-16">
                    <b-form @submit.prevent="addUser" v-if="show">
                        <div style="
                background-color: rgb(97, 116, 152);
                height: 32px;
                border-radius: 4px;
              ">
                            <h4 style="
                  color: rgb(223, 227, 238);
                  margin-left: 5px;
                  font-weight: bold;
                ">
                                MarketPlace Information
                            </h4>
                        </div>
                        <div class="row">

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Category Name:" label-for="category_id">
                                    <b-form-select id="category_id" placeholder="Select category" :state="validateField(selectedCategoryId, 'number')"
                                        v-model="selectedCategoryId" :options="categories" required
                                        @change="filterBrands"></b-form-select>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Brand Name:" label-for="brand_id">
                                    <b-form-select id="brand_id" placeholder="Select brand"  :state="validateField(selectedBrandId, 'number')" v-model="selectedBrandId"
                                        :options="filteredBrands" required @change="filterModels"></b-form-select>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Brand Model:" label-for="brand_model_id">
                                    <b-form-select id="brand_model_id" placeholder="Select brand model" :state="validateField(brand_model_id, 'number')"
                                        v-model="brand_model_id" :options="filteredModels" required></b-form-select>
                                </b-form-group>
                            </div>

                            <!-- <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Brand Name:" label-for="brand_id">
                                    <b-form-select id="brand_id" placeholder="Select brand id" v-model="brand_id" :options="brands" required>
                                    </b-form-select>
                                </b-form-group>
                            </div>
                            
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Brand Model:" label-for="brand_model_id">
                                    <b-form-select id="brand_model_id" placeholder="Select brand model" v-model="brand_model_id" :options="brandModels" required>
                                    </b-form-select>
                                </b-form-group>
                            </div> -->


                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Year:" label-for="year">
                                    <b-form-input id="year" placeholder="Enter year" :state="validateField(year, 'number')" v-model="year" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Registration In:" label-for="registration_in">
                                    <b-form-input id="registration_in" placeholder="Enter registyration  in" :state="validateField(registration_in)"
                                        v-model="registration_in" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Registration Number:"
                                    label-for="registration_number">
                                    <b-form-input id="registration_number" placeholder="Enter registration  number" :state="validateField(registration_number)"
                                        v-model="registration_number" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Engine Number:" label-for="engine_number">
                                    <b-form-input id="engine_number" placeholder="Enter engine nnumber" :state="validateField(engine_number)"
                                        v-model="engine_number" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Color:" label-for="color">
                                    <b-form-input id="color" placeholder="Enter color" :state="validateField(color)" v-model="color" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="City:" label-for="city">
                                    <b-form-input id="city" placeholder="Enter city" :state="validateField(city)" v-model="city" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Area:" label-for="area">
                                    <b-form-input id="area" placeholder="Enter area"  :state="validateField(area)" v-model="area" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Country:" label-for="country">
                                    <b-form-input id="country" placeholder="Enter country" :state="validateField(country)" v-model="country" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Mileage:" label-for="mileage">
                                    <b-form-input id="mileage" placeholder="Enter mileage" :state="validateField(mileage)" v-model="mileage" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Price:" label-for="price">
                                    <b-form-input id="price" placeholder="Enter price" :state="validateField(price)" v-model="price" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Kilometer Second Driven:"
                                    label-for="KMs_driven">
                                    <b-form-input id="KMs_driven" placeholder="Enter kilometer second" :state="validateField(KMs_driven)"
                                        v-model="KMs_driven" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Fuel Type:" label-for="fuel_type">
                                    <b-form-input id="fuel_type" placeholder="Enter fuel type" :state="validateField(fuel_type)" v-model="fuel_type"
                                        required>
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group label="Transmission Type:" label-for="transmission_type">
                                    <b-form-select id="transmission_type" v-model="transmission_type" :state="validateField(transmission_type)"
                                        :options="statusOptions" required>
                                    </b-form-select>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Engine Capacity:" label-for="engine_capacity">
                                    <b-form-input id="engine_capacity" placeholder="Enter engine capacity":state="validateField(engine_capacity)"
                                        v-model="engine_capacity" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Description:" label-for="description">
                                    <textarea class="form-control" type="text" id="description"
                                        placeholder="Enter description"  :class="{  'is-invalid': validateField(description) === false,  'is-valid': validateField(description) === true,}" v-model="description" required>
                                    </textarea>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Features:" label-for="features">
                                    <b-form-input id="features" placeholder="Enter features"  :state="validateField(features)" v-model="features"
                                        required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Assemble:" label-for="assembly">
                                    <b-form-input id="assembly" placeholder="Enter assembly" :state="validateField(assembly)" v-model="assembly"
                                        required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group label="status:" label-for="status">
                                    <b-form-select id="status" v-model="status" :state="validateField(status)"
                                        :options="statusSellNew" required>
                                    </b-form-select>
                                </b-form-group>
                            </div>
                            <!-- ...............  -->
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Documents:" label-for="image">
                                    <div style="margin-left: 3px; margin-bottom: 15px">
                                        <input type="file" accept="image/*" id="image" multiple
                                            @change="onProfilePictureChange" />
                                    </div>
                                </b-form-group>
                            </div>
                        </div>

                        <!-- Bank Information End -->
                        <b-button type="submit" variant="primary" class="mb-8 mr-8" :disabled="isLoading">
                            <span v-if="!isLoading">Submit</span>
                            <b-spinner v-else class="mb-8 mr-8" variant="primary" small></b-spinner>
                        </b-button>
                    </b-form>
                </div>

                <div v-if="codeActive" class="col-12 mt-24 hljs-container" :class="{ active: codeActiveClass }">
                    <pre v-highlightjs>
            <code class="hljs html">
              {{ codeText }}
            </code>
          </pre>
                </div>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormSelect,
    BFormInput,
    BSpinner,
} from "bootstrap-vue";
import axios from "../../../axios";
import { BToast } from "bootstrap-vue";
import code from "@/view/components/data-entry/form/code";
import imageCompression from 'browser-image-compression';

export default {
    data() {
        return {
            show: true,
            codeText: code.introduction,
            codeActive: false,
            codeActiveClass: false,
            showModal: false,
            isLoading: false,
            successMessage: "",
            errorMessage: "",
            year: "",

            categories: [],
            brands: [],
            brandModels: [],
            selectedCategoryId: null,
            selectedBrandId: null,
            brand_model_id: "",
            filteredBrands: [],
            filteredModels: [],

            registration_in: '',
            registration_number: '',
            engine_number: '',
            color: '',
            city: '',
            area: '',
            country: '',
            mileage: '',
            price: '',
            KMs_driven: '',
            fuel_type: '',
            transmission_type: '',
            engine_capacity: '',
            description: '',
            features: '',
            assembly: '',
            status: '',
            manager_id: '',
            // category:"",
            user_id: "",
            documents: [],
            image: [],
            statusOptions: [
                // { value: null, text: 'Select Transmission Type' },
                { value: 'manual', text: 'Manual' },
                { value: 'auto', text: 'Auto' }
            ],
              statusSellNew: [
                // { value: null, text: 'Select Transmission Type' },
                { value: 'sell', text: 'sell' },
                { value: 'new', text: 'new' }
            ],

        };
    },
    components: {
        BRow,
        BCol,
        BCard,
        BButton,
        BForm,
        BFormGroup,
        BFormCheckboxGroup,
        BFormCheckbox,
        BFormSelect,
        BFormInput,
        BToast,
        BSpinner,
    },
    mounted() {
        axios.get('CategoryList')
            .then(response => {
                this.categories = response.data.data.map(category => ({
                    value: category.id,
                    text: category.title
                }));
            })
            .catch(error => {
            });

        axios.get('brandList')
            .then(response => {
                this.brands = response.data.data.map(brand => ({
                    value: brand.id,
                    text: brand.name,
                    categoryId: brand.category_id,
                }));
            })
            .catch(error => {
            });
        axios.get('brandModel')
            .then(response => {

                this.brandModels = response.data.data.map(model => ({
                    value: model.id,
                    text: model.title,
                    brandId: model.brand_id,
                }));
            })
            .catch(error => {

            });
    },
    methods: {
          validateField(value, type = "text") {
            if (value === null || value === undefined || value === "") return null;

            if (type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(value);
            }
            if (type === "number") {
            const regex = /^\+?[0-9 ]+$/; // accepts + and spaces
            return regex.test(value.toString().trim());
            }
            return value.toString().trim().length > 0;
        },
        filterBrands() {
            this.filteredBrands = this.brands.filter(
                brand => brand.categoryId === this.selectedCategoryId
            );
            this.selectedBrandId = null;
            this.filteredModels = [];
        },
        filterModels() {
            this.filteredModels = this.brandModels.filter(
                model => model.brandId === this.selectedBrandId
            );
        },
        showMsgBoxOne() {
            debugger;
        },
        onSubmit(event) {
            event.preventDefault();
            alert(JSON.stringify(this.form));
            // debugger
        },



        addUser() {
            this.isLoading = true;
            // Create a FormData object to handle the image file
            const formData = new FormData();
            formData.append("year", this.year);
            formData.append("brand_model_id", this.brand_model_id);
            formData.append("brand_id", this.selectedBrandId);
            formData.append("category_id", this.selectedCategoryId);
            formData.append("registration_number", this.registration_number);
            formData.append("engine_number", this.engine_number);
            formData.append("registration_in", this.registration_in);
            formData.append("color", this.color);
            formData.append("city", this.city);
            formData.append("area", this.area);
            formData.append("country", this.country);
            formData.append("mileage", this.mileage);
            formData.append("price", this.price);
            formData.append("KMs_driven", this.KMs_driven);
            formData.append("fuel_type", this.fuel_type);
            formData.append("transmission_type", this.transmission_type);
            formData.append("engine_capacity", this.engine_capacity);
            formData.append("description", this.description);
            formData.append("features", this.features);
            formData.append("assembly", this.assembly);
            formData.append("status", this.status);
            formData.append("user_id", 1);
            this.managerId = localStorage.getItem("userId");
            this.type = localStorage.getItem("type");
            if (this.type === "manager") {
            formData.append("manager_id", this.managerId);
             }
            // formData.append("category", this.category);
            // Document code here  
            //      if (this.documents && this.documents.length > 0) {
            //     this.documents.forEach((file, index) => {
            //         formData.append(`document[${index}]`, file);
            //     });
            // }
            if (this.image && this.image.length > 0) {
                this.image.forEach((file, index) => {
                    formData.append(`image[${index}]`, file);
                });
            }
            this.type = localStorage.getItem("type");
            const endpoint = this.type === "manager" ? "marketPlaceStoreForNewManager" : "marketPlaceStoreForNew";
            axios.post(endpoint, formData)
                .then((response) => {

                    this.$bvToast.toast("Marketplace added successfully!", {
                        title: "Success",
                        variant: "primary",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 5000,
                    });
                    this.isLoading = false;
                    this.$router.push({ name: 'ListMarketPlaceManager' });
                })
                .catch((error) => {
                    this.errors = error.response.data.errors;
                    this.isLoading = false;
                });
        },

        // onProfilePictureChange(event) {
        //     const files = event.target.files;

        //     if (files && files.length > 0) {
        //         if (files.length > 10) {
        //             // Show an error message if more than 3 images are selected
        //             this.$bvToast.toast("You can only upload up to 3 images.", {
        //                 title: "Error",
        //                 variant: "danger",
        //                 solid: true,
        //                 appendToast: true,
        //                 toaster: "b-toaster-top-right",
        //                 autoHideDelay: 5000,
        //                 variant: "primary",
        //             });

        //             // Optionally, trim the selection to the first 3 images
        //             this.image = Array.from(files).slice(0, 10);
        //         } else {
        //             // Store the selected images if 3 or fewer are selected
        //             this.image = Array.from(files);
        //         }
        //     }
        // },
    
        async onProfilePictureChange(event) {
    const files = event.target.files;

    if (files && files.length > 0) {
        // Validate number of files
        if (files.length > 10) {
            this.$bvToast.toast("You can only upload up to 10 images.", {
                title: "Error",
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-right",
                autoHideDelay: 5000,
            });
            
            // Trim selection to first 10 images
            files = Array.from(files).slice(0, 10);
        }

        try {
            this.isLoading = true; // Show loading state if needed
            
            // Compression options
            const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 1024,
                useWebWorker: true
            };

            // Compress all selected images
            const compressionPromises = Array.from(files).map(file => 
                imageCompression(file, options)
            );

            // Wait for all compressions to complete
            const compressedFiles = await Promise.all(compressionPromises);
            
            // Store compressed files
            this.image = compressedFiles;
            
            // Log compression results
            compressedFiles.forEach(file => {
                console.log("Compressed image size:", file.size / 1024 / 1024, "MB");
            });
            
        } catch (error) {
            console.error("Image compression error:", error);
            this.$bvToast.toast("Error compressing images. Using original files.", {
                title: "Warning",
                variant: "warning",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-right",
                autoHideDelay: 5000,
            });
            
            // Fallback to original files if compression fails
            this.image = Array.from(files);
        } finally {
            this.isLoading = false;
        }
    }
},
        codeClick() {
            this.codeActive = !this.codeActive;
        },

        saveOwnCar() {
            this.showModal = false;
        },

        onDocumentsChange(event) {
            const files = event.target.files;
            if (files && files.length > 0) {
                if (files.length > 3) {
                    this.$bvToast.toast("You can only upload up to 3 documents.", {
                        title: "Error",
                        variant: "danger",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 5000,
                    });

                    this.documents = Array.from(files).slice(0, 3);
                } else {
                    this.documents = Array.from(files);
                }
            }
        },
    },
};
</script>